// extracted by mini-css-extract-plugin
module.exports = {"link_text":"style_link_text__nmEen","description":"style_description__XHFjv"};